// Stub: will be replaced by real API calls
export const mockAnalyticsMetrics: any = {};
export const mockTopPerformingMerchants: any[] = [];
export const mockCategoryPerformance: any[] = [];
export const mockRevenueData: any[] = [];
